<template>
    
    <show :detailDef="detailDef"
          :moduleRoute ="moduleRoute"
          :modelData ="modelData"
          :relationData ="relationData"
          :slug="slug"
          :currentProduct="currentProduct"
          :moduleLabel="moduleLabel"
          >
  
      <template v-slot:action_btn>
                <jet-button  @click="publishProduct" class="bg-purple-500   text-white hover:bg-purple-500  hover:no-underline px-2 cursor-pointer  text-sm">Publish</jet-button>
  
      </template>
         
  
    </show>
  
  
  </template>
  
  <script>
  import Show from '@include/pages/BaseShowView.vue';
  import JetNavLink from '@/Jetstream/NavLink.vue';
  import JetButton from "@/Jetstream/Button.vue";
  
  
  export default {
  
      props: { detailDef:{
                  type: Array,
                  default: []
              },
              moduleRoute:String,
              modelData:{
                  type: Object,
                  default: () => ({})
              },
              relationData :{
                  type: Array,
                  default: []
              },
              route:"",
              slug: String,
              currentProduct: String,
              moduleLabel: String,
              
              },
      components: {
          Show,
          JetNavLink,
          JetButton,
      },
      mixins: [
          //
      ],
      data() {
          return {
          form: this.$inertia.form(),
  
          }
      },
      computed: {
          //
          
      },
      methods: {
        publishProduct(){
  
         // this.$inertia.post(this.route, this.form.data());
        console.log("ModelRoute",this.moduleRoute);
        //this.$inertia.post(this.moduleRoute+"/deploy", this.modelData.id);
        //this.form.get(route(this.moduleRoute+".deploy",this.modelData.id));
  
        }
        
  
      },
      created() {
          //    
          console.log("aagya");
      },
      mounted() {
          //
      }
  
  
  }
  </script>
  
  <style>
  
  </style>